export enum CartActionType {
  CART_ADD_ITEMS = "add_items",
  CART_REMOVE_ITEMS = "remove_items",
  CART_SAVE_SHIPPING_ADDRESS = "save_shipping_address",
  CART_SAVE_PAYMENT_METHOD = "save_payment_method",
}
